module.exports = __webpack_public_path__ + "img/smile2.61d42020.png";